import { AccountInfo, EventType, RedirectRequest } from "@azure/msal-browser";
import { loginRequest } from "./authConfig";
import msalInstance from "./msal-instance";
import i18n from "../../i18n";

class MsalService {
  public async initialize(callback: () => void): Promise<void> {
    await msalInstance.initialize();

    const redirectResult = await msalInstance.handleRedirectPromise();
    console.log("MsalService.initialize: handleRedirectPromise result", {
      hasResult: !!redirectResult,
      hasAccount: !!redirectResult?.account,
    });

    if (redirectResult?.account) {
      console.log("MsalService.initialize: setting active account from redirect");
      msalInstance.setActiveAccount(redirectResult.account);
    }

    const existingAccount = this.getAccount();
    console.log("MsalService.initialize: checking for existing account", {
      hasExistingAccount: !!existingAccount,
      accountId: existingAccount?.localAccountId,
    });

    if (existingAccount) {
      console.log("MsalService.initialize: found account, setting active and calling callback");
      msalInstance.setActiveAccount(existingAccount);
      callback();
    }

    msalInstance.addEventCallback((event: any) => {
      console.log("MsalService.addEventCallback", {
        eventType: event.eventType,
        hasPayload: !!event.payload,
        hasAccount: !!event.payload?.account,
      });

      if (
        // (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === EventType.SSO_SILENT_SUCCESS) &&
        (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || event.eventType === EventType.LOGIN_SUCCESS) &&
        event.payload
      ) {
        const payload = event.payload as any;
        if (payload.account) {
          console.log("MsalService: LOGIN_SUCCESS or ACQUIRE_TOKEN_SUCCESS, calling callback");
          msalInstance.setActiveAccount(payload.account);
          callback();
        }
      }
    });
  }

  public async getToken(account: AccountInfo): Promise<string | undefined> {
    const request: any = {
      ...loginRequest,
      account: account,
    };
    try {
      const response = await msalInstance.acquireTokenSilent(request);
      if (response?.accessToken) return response.accessToken;
      return response.idToken;
    } catch (error) {
      console.error(`Error while acquiring token: ${error}`);
      msalInstance.acquireTokenRedirect(request);
      return undefined;
    }
  }

  public async login() {
    let request: RedirectRequest = {
      ...loginRequest,
      extraQueryParameters: { ui_locales: `${i18n.language}-ca` },
      prompt: "login",
    };
    await msalInstance.loginRedirect(request).catch((e) => {
      console.error(e);
    });
  }

  public async signup() {
    let request: RedirectRequest = {
      ...loginRequest,
      extraQueryParameters: { ui_locales: `${i18n.language}-ca` },
      prompt: "create",
    };
    await msalInstance.loginRedirect(request).catch((e) => {
      console.error(e);
    });
  }

  public async logout(redirectUrl: string): Promise<void> {
    msalInstance.clearCache();
    await msalInstance.logoutRedirect({
      postLogoutRedirectUri: redirectUrl,
    });
  }

  getAccount(): AccountInfo | null {
    return msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0] ?? null;
  }
}

const msalService = new MsalService();
export default msalService;
